import { NEW_RESOURCE_ID } from '@config'

const collectionDefaults = {
  id: NEW_RESOURCE_ID,
  game_id: 2,
  status: 1,
  visible: 0,
  submitted_by: {},
  category: 0,
  date_added: 123,
  date_updated: 123,
  date_live: 0,
  date_disabled: 0,
  limit_number_mods: 100,
  incomplete: 0,
  maturity_option: 0,
  filesize: 0,
  platforms: [],
  tags: [],
  stats: {
    downloads_today: 0,
    downloads_unique: 0,
    downloads_total: 0,
    followers_total: 0,
    ratings_positive_30days: 0,
    ratings_negative_30days: 0,
    ratings_total_30days: 0,
    ratings_positive: 0,
    ratings_negative: 0,
    ratings_total: 0,
    comments_total: 0,
    mods_total: 0,
  },
  logo: {
    filename: null,
    original: null,
    thumb_320x180: null,
    thumb_640x360: null,
    thumb_1280x720: null,
  },
  name: '',
  name_id: '',
  summary: '',
  description: '',
}

export default collectionDefaults
